/* eslint-disable prettier/prettier */
import isNumber from "lodash/isNumber";
import { OS_KEYS } from "../contants";
import { REGEX } from "./validation/regex";

export const handleValidation = (FIELDS, values, skip = []) => {
  if (!values[FIELDS.NAME] || !values[FIELDS.NAME].length) {
    return {
      message: "Please enter Name",
      severity: "error",
    };
  }
  if (
    !skip.includes(FIELDS.ADDRESS_LINE_1) &&
    (!values[FIELDS.ADDRESS_LINE_1] || !values[FIELDS.ADDRESS_LINE_1].length)
  ) {
    return {
      message: "Please enter Address",
      severity: "error",
    };
  }
  if (
    skip.includes(FIELDS.ADDRESS_LINE_1) &&
    (!values[FIELDS.ADDRESS] || !values[FIELDS.ADDRESS].length)
  ) {
    return {
      message: "Please enter Address",
      severity: "error",
    };
  }
  if (
    !values[FIELDS.ADDRESS_LINE_1] ||
    String(values[FIELDS.ADDRESS_LINE_1]).length < 5
  ) {
    return {
      message: "Please enter valid Address",
      severity: "error",
    };
  }
  if (!Number(values[FIELDS.STATE])) {
    return {
      message: "Please select State",
      severity: "error",
    };
  }
  if (!Number(values[FIELDS.CITY])) {
    return {
      message: "Please select City",
      severity: "error",
    };
  }

  // if (!values[FIELDS.PINCODE] || String(values[FIELDS.PINCODE]).length !== 6) {
  //   return {
  //     message: "Please enter correct Pincode",
  //     severity: "error",
  //   };
  // }
  if (
    !values[FIELDS.CONTACT_NUMBER] ||
    String(values[FIELDS.CONTACT_NUMBER]).length !== 10
  ) {
    return {
      message: "Please enter Contact Number",
      severity: "error",
    };
  }

  if (!Number(values[FIELDS.DIVISION])) {
    return {
      message: "Please select Division",
      severity: "error",
    };
  }

  if (
    (values[FIELDS.DIVISION] === 52 || values[FIELDS.DIVISION] === 53) &&
    Number(!values[FIELDS.SUB_DIVISION])
  ) {
    return {
      message: "Please enter Sub Division",
      severity: "error",
    };
  }

  if (
    (values[FIELDS.DIVISION] === 52 || values[FIELDS.DIVISION] === 53) &&
    (!values[FIELDS.PARENT_CONTACT_NUMBER] ||
      String(values[FIELDS.PARENT_CONTACT_NUMBER]).length !== 10)
  ) {
    return {
      message: "Please enter Parent's Contact Number",
      severity: "error",
    };
  }

  if (!values[FIELDS.NATIONALITY_ID]) {
    return {
      message: "Please select country",
      severity: "error",
    };
  }

  if (
    !values[FIELDS.INTRODUCED_BY_NAME] ||
    !values[FIELDS.INTRODUCED_BY_NAME].length
  ) {
    return {
      message: "Please enter Introducer's Name",
      severity: "error",
    };
  }

  if (
    !values[FIELDS.INTRODUCED_BY_MOBILE_NUMBER] ||
    String(values[FIELDS.INTRODUCED_BY_MOBILE_NUMBER]).length !== 10
  ) {
    return {
      message: "Please enter 'Introducer's contact number",
      severity: "error",
    };
  }

  // OLD (kept for future reference): Introducer email was considered mandatory.
  // This caused usability issues, so it was disabled.
  // if (
  //   !values[FIELDS.INTRODUCED_BY_EMAIL] ||
  //   !values[FIELDS.INTRODUCED_BY_EMAIL].length
  // ) {
  //   return {
  //     message: "Please enter Introducer Email",
  //     severity: "error",
  //   };
  // }

  // NEW: Email fields are optional, but if provided they must be valid emails.
  // const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const emailRegex = REGEX.EMAIL_SIMPLE;
  const emailAddress = values?.[FIELDS.EMAIL_ADDRESS]
    ? String(values[FIELDS.EMAIL_ADDRESS]).trim()
    : "";
  if (emailAddress && !emailRegex.test(emailAddress)) {
    return {
      message: "Please enter valid Email Address",
      severity: "error",
    };
  }

  const introducerEmailAddress = values?.[FIELDS.INTRODUCED_BY_EMAIL]
    ? String(values[FIELDS.INTRODUCED_BY_EMAIL]).trim()
    : "";
  if (introducerEmailAddress && !emailRegex.test(introducerEmailAddress)) {
    return {
      message: "Please enter valid Introducer's Email Address",
      severity: "error",
    };
  }

  if (!Number(values.areaId)) {
    return {
      message: "Please select area",
      severity: "error",
    };
  }

  return {};
};

export const handleFriendsValidation = (FIELDS, values, skip = []) => {
  if (!values[FIELDS.NAME] || !values[FIELDS.NAME].length) {
    return {
      message: "Please enter Name",
      severity: "error",
    };
  }
  if (
    !skip.includes(FIELDS.ADDRESS_LINE_1) &&
    (!values[FIELDS.ADDRESS_LINE_1] || !values[FIELDS.ADDRESS_LINE_1].length)
  ) {
    return {
      message: "Please enter Address",
      severity: "error",
    };
  }
  if (
    skip.includes(FIELDS.ADDRESS_LINE_1) &&
    (!values[FIELDS.ADDRESS] || !values[FIELDS.ADDRESS].length)
  ) {
    return {
      message: "Please enter Address",
      severity: "error",
    };
  }
  if (
    !values[FIELDS.ADDRESS_LINE_1] ||
    String(values[FIELDS.ADDRESS_LINE_1]).length < 5
  ) {
    return {
      message: "Please enter valid Address",
      severity: "error",
    };
  }
  if (!Number(values[FIELDS.STATE])) {
    return {
      message: "Please select State",
      severity: "error",
    };
  }
  if (!Number(values[FIELDS.CITY])) {
    return {
      message: "Please select City",
      severity: "error",
    };
  }

  // if (!values[FIELDS.PINCODE] || String(values[FIELDS.PINCODE]).length !== 6) {
  //   return {
  //     message: "Please enter correct Pincode",
  //     severity: "error",
  //   };
  // }
  if (
    !values[FIELDS.CONTACT_NUMBER] ||
    String(values[FIELDS.CONTACT_NUMBER]).length !== 10
  ) {
    return {
      message: "Please enter Contact Number",
      severity: "error",
    };
  }

  if (!Number(values[FIELDS.DIVISION])) {
    return {
      message: "Please select Division",
      severity: "error",
    };
  }

  if (
    (values[FIELDS.DIVISION] === 52 || values[FIELDS.DIVISION] === 53) &&
    Number(!values[FIELDS.SUB_DIVISION])
  ) {
    return {
      message: "Please enter Sub Division",
      severity: "error",
    };
  }

  if (
    (values[FIELDS.DIVISION] === 52 || values[FIELDS.DIVISION] === 53) &&
    (!values[FIELDS.PARENT_CONTACT_NUMBER] ||
      String(values[FIELDS.PARENT_CONTACT_NUMBER]).length !== 10)
  ) {
    return {
      message: "Please enter Parent's Contact Number",
      severity: "error",
    };
  }
  if (
    (values[FIELDS.DIVISION] === 52 || values[FIELDS.DIVISION] === 53) &&
    !values[FIELDS.PARENT_EMAIL_ADDRESS]
  ) {
    return {
      message: "Please enter Parent's Email Address",
      severity: "error",
    };
  }
  if (!values[FIELDS.PROFESSION]) {
    return {
      message: "Please select Profession",
      severity: "error",
    };
  }
  if (!values[FIELDS.NATIONALITY_ID]) {
    return {
      message: "Please select country",
      severity: "error",
    };
  }

  if (
    !values[FIELDS.INTRODUCED_BY_NAME] ||
    !values[FIELDS.INTRODUCED_BY_NAME].length
  ) {
    return {
      message: "Please enter Introducer Name",
      severity: "error",
    };
  }

  if (
    !values[FIELDS.INTRODUCED_BY_MOBILE_NUMBER] ||
    String(values[FIELDS.INTRODUCED_BY_MOBILE_NUMBER]).length !== 10
  ) {
    return {
      message: "Please enter Introducer contact number",
      severity: "error",
    };
  }

  // if (
  //   !values[FIELDS.INTRODUCED_BY_EMAIL] ||
  //   !values[FIELDS.INTRODUCED_BY_EMAIL].length
  // ) {
  //   return {
  //     message: "Please enter Introducer Email",
  //     severity: "error",
  //   };
  // }

  if (!Number(values.areaId)) {
    return {
      message: "Please select area",
      severity: "error",
    };
  }

  if (!Number(values.blockId)) {
    return {
      message: "Please select block",
      severity: "error",
    };
  }

  return {};
};

export const handleFriendsToMemberValidation = (FIELDS, values, skip = []) => {
  if (!values[FIELDS.NAME] || !values[FIELDS.NAME].length) {
    return {
      message: "Please enter Name",
      severity: "error",
    };
  }
  if (
    !skip.includes(FIELDS.ADDRESS_LINE_1) &&
    (!values[FIELDS.ADDRESS_LINE_1] || !values[FIELDS.ADDRESS_LINE_1].length)
  ) {
    return {
      message: "Please enter Address",
      severity: "error",
    };
  }
  if (
    skip.includes(FIELDS.ADDRESS_LINE_1) &&
    (!values[FIELDS.ADDRESS] || !values[FIELDS.ADDRESS].length)
  ) {
    return {
      message: "Please enter Address",
      severity: "error",
    };
  }
  if (
    !values[FIELDS.ADDRESS_LINE_1] ||
    String(values[FIELDS.ADDRESS_LINE_1]).length < 5
  ) {
    return {
      message: "Please enter valid Address",
      severity: "error",
    };
  }
  if (!Number(values[FIELDS.STATE])) {
    return {
      message: "Please select State",
      severity: "error",
    };
  }
  if (!Number(values[FIELDS.CITY])) {
    return {
      message: "Please select City",
      severity: "error",
    };
  }

  // if (!values[FIELDS.PINCODE] || String(values[FIELDS.PINCODE]).length !== 6) {
  //   return {
  //     message: "Please enter correct Pincode",
  //     severity: "error",
  //   };
  // }
  if (
    !values[FIELDS.CONTACT_NUMBER] ||
    String(values[FIELDS.CONTACT_NUMBER]).length !== 10
  ) {
    return {
      message: "Please enter Contact Number",
      severity: "error",
    };
  }

  if (!Number(values[FIELDS.DIVISION])) {
    return {
      message: "Please select Division",
      severity: "error",
    };
  }

  if (
    (values[FIELDS.DIVISION] === 52 || values[FIELDS.DIVISION] === 53) &&
    Number(!values[FIELDS.SUB_DIVISION])
  ) {
    return {
      message: "Please enter Sub Division",
      severity: "error",
    };
  }

  if (
    (values[FIELDS.DIVISION] === 52 || values[FIELDS.DIVISION] === 53) &&
    (!values[FIELDS.PARENT_CONTACT_NUMBER] ||
      String(values[FIELDS.PARENT_CONTACT_NUMBER]).length !== 10)
  ) {
    return {
      message: "Please enter Parent's Contact Number",
      severity: "error",
    };
  }
  if (
    (values[FIELDS.DIVISION] === 52 || values[FIELDS.DIVISION] === 53) &&
    !values[FIELDS.PARENT_EMAIL_ADDRESS]
  ) {
    return {
      message: "Please enter Parent's Email Address",
      severity: "error",
    };
  }
  // if (!values[FIELDS.PROFESSION]) {
  //   return {
  //     message: "Please select Profession",
  //     severity: "error",
  //   };
  // }
  if (!values[FIELDS.NATIONALITY_ID]) {
    return {
      message: "Please select country",
      severity: "error",
    };
  }

  if (
    !values[FIELDS.INTRODUCED_BY_NAME] ||
    !values[FIELDS.INTRODUCED_BY_NAME].length
  ) {
    return {
      message: "Please enter Introducer Name",
      severity: "error",
    };
  }

  if (
    !values[FIELDS.INTRODUCED_BY_MOBILE_NUMBER] ||
    String(values[FIELDS.INTRODUCED_BY_MOBILE_NUMBER]).length !== 10
  ) {
    return {
      message: "Please enter Introducer contact number",
      severity: "error",
    };
  }

  // if (
  //   !values[FIELDS.INTRODUCED_BY_EMAIL] ||
  //   !values[FIELDS.INTRODUCED_BY_EMAIL].length
  // ) {
  //   return {
  //     message: "Please enter Introducer Email",
  //     severity: "error",
  //   };
  // }

  if (!Number(values.areaId)) {
    return {
      message: "Please select area",
      severity: "error",
    };
  }

  if (!Number(values.blockId)) {
    return {
      message: "Please select block",
      severity: "error",
    };
  }

  return {};
};

export const handleNewMemberValidation = (FIELDS, values, skip = []) => {
  if (!values[FIELDS.NAME] || !values[FIELDS.NAME].length) {
    return {
      message: "Please enter Name",
      severity: "error",
    };
  }
  if (
    !skip.includes(FIELDS.ADDRESS_LINE_1) &&
    (!values[FIELDS.ADDRESS_LINE_1] || !values[FIELDS.ADDRESS_LINE_1].length)
  ) {
    return {
      message: "Please enter Address",
      severity: "error",
    };
  }
  if (
    skip.includes(FIELDS.ADDRESS_LINE_1) &&
    (!values[FIELDS.ADDRESS] || !values[FIELDS.ADDRESS].length)
  ) {
    return {
      message: "Please enter Address",
      severity: "error",
    };
  }
  if (
    !values[FIELDS.ADDRESS_LINE_1] ||
    String(values[FIELDS.ADDRESS_LINE_1]).length < 5
  ) {
    return {
      message: "Please enter valid Address",
      severity: "error",
    };
  }
  if (!Number(values[FIELDS.STATE])) {
    return {
      message: "Please select State",
      severity: "error",
    };
  }
  if (!Number(values[FIELDS.CITY])) {
    return {
      message: "Please select City",
      severity: "error",
    };
  }
  if (
    !values[FIELDS.CONTACT_NUMBER] ||
    String(values[FIELDS.CONTACT_NUMBER]).length !== 10
  ) {
    return {
      message: "Please enter Contact Number",
      severity: "error",
    };
  }

  if (!Number(values[FIELDS.DIVISION])) {
    return {
      message: "Please select Division",
      severity: "error",
    };
  }

  if (
    (values[FIELDS.DIVISION] === 52 || values[FIELDS.DIVISION] === 53) &&
    Number(!values[FIELDS.SUB_DIVISION])
  ) {
    return {
      message: "Please enter Sub Division",
      severity: "error",
    };
  }

  if (
    (values[FIELDS.DIVISION] === 52 || values[FIELDS.DIVISION] === 53) &&
    (!values[FIELDS.PARENT_CONTACT_NUMBER] ||
      String(values[FIELDS.PARENT_CONTACT_NUMBER]).length !== 10)
  ) {
    return {
      message: "Please enter Parent's Contact Number",
      severity: "error",
    };
  }
  if (
    (values[FIELDS.DIVISION] === 52 || values[FIELDS.DIVISION] === 53) &&
    !values[FIELDS.PARENT_EMAIL_ADDRESS]
  ) {
    return {
      message: "Please enter Parent's Email Address",
      severity: "error",
    };
  }
  if (!values[FIELDS.NATIONALITY_ID]) {
    return {
      message: "Please select country",
      severity: "error",
    };
  }

  if (
    !values[FIELDS.INTRODUCED_BY_NAME] ||
    !values[FIELDS.INTRODUCED_BY_NAME].length
  ) {
    return {
      message: "Please enter Introducer Name",
      severity: "error",
    };
  }

  if (
    !values[FIELDS.INTRODUCED_BY_MOBILE_NUMBER] ||
    String(values[FIELDS.INTRODUCED_BY_MOBILE_NUMBER]).length !== 10
  ) {
    return {
      message: "Please enter Introducer contact number",
      severity: "error",
    };
  }
  if (!Number(values.areaId)) {
    return {
      message: "Please select area",
      severity: "error",
    };
  }
  if (!Number(values.clusterId)) {
    return {
      message: "Please select cluster",
      severity: "error",
    };
  }
  if (!Number(values.zoneId)) {
    return {
      message: "Please select zone",
      severity: "error",
    };
  }
  if (!Number(values.regionId)) {
    return {
      message: "Please select region",
      severity: "error",
    };
  }
  if (!Number(values.chapterId)) {
    return {
      message: "Please select chapter",
      severity: "error",
    };
  }
  if (!Number(values.districtId)) {
    return {
      message: "Please select district",
      severity: "error",
    };
  }
  if (!Number(values.blockId)) {
    return {
      message: "Please select block",
      severity: "error",
    };
  }

  return {};
};

export const getOptions = (options, key) =>
  options?.map((opt) => ({
    ...opt,
    value: opt[key],
  }));

export const getDropdownOptions = (options, key, value) =>
  options?.map((opt) => ({
    key: opt[key],
    value: opt[value],
  }));

export const getOSCollective = (data) => {
  const osKeysWithName = OS_KEYS.map((key) => `${key.split("Id")[0]}Name`);

  return osKeysWithName
    .reduce((result, key) => {
      return result + (data[key] ? `${data[key]}/` : "");
    }, "")
    ?.slice(0, -1);
};

// export const getGohonzonType = (gohonzon) => {
//   return gohonzon?.length ? gohonzon.split("_")[0] : "-";
// };

export const getGohonzonType = (gohonzon) => {
  if (gohonzon === "OKATAKI_GOHONZON") {
    return "GOHONZON";
  }
  return gohonzon?.length ? gohonzon.split("_")[0] : "NA";
};

// ToDo: remove
export const isInteger = (value) => !Number.isNaN(Number(value));

export const validNumber = (number) => isNumber(number);

export const prepareRemarkPayload = (remarks, success = false) => ({
  reason: {
    data: {
      message: remarks,
      event: success ? "success" : "rejection",
    },
  },
});

export const getAppointmentType = (appointment) => {
  return appointment?.length ? appointment.split("_")[0] : "-";
};

export const getDirectAppointmentType = (positionType) => {
  if (positionType === "DEPUTY_POSITION") {
    return "DUAL";
  }
  return positionType?.length ? positionType.split("_")[0] : "NA";
};

export const handleTransferValidation = (FIELDS, values, skip = []) => {
  if (
    !skip.includes(FIELDS.ADDRESS_LINE_1) &&
    (!values[FIELDS.ADDRESS_LINE_1] || !values[FIELDS.ADDRESS_LINE_1].length)
  ) {
    return {
      message: "Please enter Address 1",
      severity: "error",
    };
  }
  if (
    skip.includes(FIELDS.ADDRESS_LINE_1) &&
    (!values[FIELDS.ADDRESS] || !values[FIELDS.ADDRESS].length)
  ) {
    return {
      message: "Please enter Address",
      severity: "error",
    };
  }
  if (String(values[FIELDS.ADDRESS]).length < 5) {
    return {
      message: "Please enter valid Address",
      severity: "error",
    };
  }
  if (!Number(values[FIELDS.STATE])) {
    return {
      message: "Please select State",
      severity: "error",
    };
  }
  if (!Number(values[FIELDS.CITY])) {
    return {
      message: "Please select City",
      severity: "error",
    };
  }

  if (
    !values[FIELDS.CONTACT_NUMBER] ||
    String(values[FIELDS.CONTACT_NUMBER]).length !== 10
  ) {
    return {
      message: "Please enter Contact Number",
      severity: "error",
    };
  }

  if (
    (values[FIELDS.DIVISION] === 52 || values[FIELDS.DIVISION] === 53) &&
    (!values[FIELDS.PARENT_CONTACT_NUMBER] ||
      String(values[FIELDS.PARENT_CONTACT_NUMBER]).length !== 10)
  ) {
    return {
      message: "Please enter Parent's Contact Number",
      severity: "error",
    };
  }
  if (
    !values[FIELDS.INTRODUCED_BY_MOBILE_NUMBER] ||
    String(values[FIELDS.INTRODUCED_BY_MOBILE_NUMBER]).length !== 10
  ) {
    return {
      message: "Please enter Introducer contact number",
      severity: "error",
    };
  }

  if (!Number(values.areaId)) {
    return {
      message: "Please select area",
      severity: "error",
    };
  }

  return {};
};
